import { UserService } from '../services/v2/user.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppyUser } from '../model/v2/AppyUser';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public subPatients = false;
  public user: AppyUser;

  constructor(public userService: UserService, public router: Router) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (x) => { this.user = x; },
      (error) => { console.error(error); });
  }

  stopImpersonating() {
    this.userService.cancelImpersonate();
    // this.userService.stopImpersonating().subscribe(
    //   (_) => { window.location.reload(false); },
    //   (error) => { console.error(error); });
  }

  appyHealthUserActive() {
    return (this.router.isActive('/admin/users', true) || this.router.isActive('/admin/users/adminusers', true)) ? 'selected' : '';
  }
}
